
import { defineComponent } from 'vue';
import backToTeacherHome from '@/lib/backToTeacherHome';
import { Router } from 'vue-router';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/back.svg';
import '@/assets/icons/add.svg';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import { Button, Pagination, Table } from 'ant-design-vue';
import asynButtonVue from '@/components/asynButton.vue';
import { JobDetailList, JobDetailListController } from './js/jobDetailList';

export default defineComponent({
  name: 'JobDetailList',
  components: {
    ManagementFrame,
    SvgIcon,
    aButton: asynButtonVue,
    aPagination: Pagination,
    aTable: Table,
  },
  methods: {
    backToTeacherHome: (r: Router) => backToTeacherHome(r),
  },
  setup() {
    const jobDetailList = new JobDetailList();
    const jobDetailListController = new JobDetailListController(jobDetailList);
    return {
      jobDetailList,
      jobDetailListController,
    };
  },
});
